module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-jenny.1ce52f46.jpg";